import React from "react";
import styled from "styled-components";
import github from "../mobile/icons/icons8_github_Footer.svg";
import linkein from "../mobile/icons/icons8_linkedin_Footer.svg";
import twitter from "../mobile/icons/icons8_twitter_Footer.svg";

export default function footer() {
  return (
    <Footer>
      <div className="icon-container">
        <span className="icon-span"></span>
        <ul className="icon-ul">
          <li className="icon-li">
            <a
              className="icon-link"
              target="_blank"
              href="http://github.com/iconicspidey"
            >
              <img src={github} alt="" />
            </a>
          </li>

          <li className="icon-li">
            <a className="icon-link" target="_blank" href="#">
              <img src={linkein} alt="" />
            </a>
          </li>

          <li className="icon-li">
            <a
              className="icon-link"
              target="_blank"
              href="http://twitter.com/iconicspidey"
            >
              <img src={twitter} alt="" />
            </a>
          </li>
        </ul>
        <span className="icon-span icon-line"></span>
      </div>
      <div className="owner">
        <p className="year">&copy; 2022</p>
        <span>|</span>
        <div className="mail">yahuzaspidey@gmail.com</div>
        <span>|</span>
        <div className="rights">All rights reserved</div>
      </div>
    </Footer>
  );
}

const Footer = styled.footer`
  background-color: ${(props) => props.theme.colors.border};
  height: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  .icon-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 23px;

    .icon-span {
      width: 50%;
      height: 3px;
      border-radius: 5px 5px;
      background-color: ${(props) => props.theme.colors.primarycolor};
    }

    .icon-ul {
      display: flex;
      gap: 20px;
      .icon-li {
        list-style: none;
        .icon-link {
          text-decoration: none;
          img {
            height: 22px;
            width: 22px;
          }
        }
      }
    }
    @media (min-width: 800px) {
      width: 300px;
      justify-content: flex-start;

      gap: 30px;
      .icon-ul {
        gap: 40px;
      }
      .icon-line {
        display: none;
      }
      .icon-span {
        width: 100px;
      }
    }
  }
  .owner {
    display: flex;
    gap: 10px;
    color: ${(props) => props.theme.colors.primarycolor};
    font-size: 12px;
    .mail {
      font-weight: 600;
    }
    span {
      font-weight: 500;
    }
  }
  @media (min-width: 800px) {
    justify-content: space-between;
    flex-direction: row;
    .owner {
      margin-right: 50px;
    }
  }
`;
